import remoteConfigSlice from './index';

// eslint-disable-next-line import/prefer-default-export
export const { setRemoteConfig } = remoteConfigSlice.actions;
